import type { ReactNode } from "react";

/** Empty/loading placeholder enforcing the copy grammar:
 *  "Loading <thing>…" (query pending) · "No <thing> yet." (loaded, empty) · "Waiting for <event>…" (live feed idle). */
export function EmptyState({ size = "md", children, testid }: {
  size?: "sm" | "md" | "lg";
  children: ReactNode;
  testid?: string;
}) {
  return <div className={`empty ${size === "md" ? "" : size}`} data-testid={testid}>{children}</div>;
}
